export const messages = {
  submitAudio:
    "Submitted Successfully, it will take a few seconds to process the answer!",
  somethingWentWrong: "Something went wrong!",
  selectText: "Please select or enter the text",
  recordAudio: "Please record or select your audio",
  dateErr: "End date should be less than start date!",
  emailSentConfirmation:
    "A verification code has been sent to your email address. Please enter the verification code to confirm your email address!",
  userCreation: "User Created Successfully!",
};
